import { render, staticRenderFns } from "./BattlesBanner.vue?vue&type=template&id=2b125c1e&scoped=true&lang=pug&"
import script from "./BattlesBanner.vue?vue&type=script&lang=js&"
export * from "./BattlesBanner.vue?vue&type=script&lang=js&"
import style0 from "./BattlesBanner.vue?vue&type=style&index=0&id=2b125c1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b125c1e",
  null
  
)

export default component.exports